// This TypeScript function appears to be a utility function that retrieves a nested value from an object based on a given path. - ChatGPT,
// TODO don't use `any`
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getFieldFromPath = (obj: unknown, path: any, defValue?: unknown) => {
  // If path is not defined or it has false value
  if (!path) return undefined;
  // Check if path is string or array. Regex : ensure that we do not have '.' and brackets.
  // Regex explained: https://regexr.com/58j0k
  const pathArray = Array.isArray(path) ? path : path.match(/([^[.\]])+/g);
  // Find value
  // TODO don't use `any`
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const result = pathArray.reduce((prevObj: any, key: any) => prevObj && prevObj[key], obj);
  // If found value is undefined return default value; otherwise return the value
  return result === undefined ? getFieldFromRawPath(obj, path, defValue) : result;
};

// TODO don't use `any`
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getFieldFromRawPath = (obj: unknown, path: any, defValue?: unknown) => {
  // allows to get fields from raw string path names (including dots (.))
  if (!path) return undefined;

  const result = (obj as never)[path];
  return result === undefined ? defValue : result;
};
